import { CartData, saveCart, saveCartId } from "@origin-digital/sales-cart";
import { ILPGOffer } from "../model/ILPGOffer";

export const savePlanToCart = async (
  originAddressId: string,
  cartServiceEndPoint: string,
  lpgOffer: ILPGOffer
) => {
  const payload: ILPGOffer = {
    ...lpgOffer,
    rewardOffer: Boolean(lpgOffer?.rewardOffer),
  };

  const cartData: CartData = {
    addressId: originAddressId,
    channel: "LPG",
    status: "IN_PROGRESS",
    lpg: {
      payload,
    },
  };

  const cartId = await saveCart(cartServiceEndPoint, cartData);
  saveCartId(cartId);
};
